import { render } from "./AddVideoPage.vue?vue&type=template&id=c27ee726&scoped=true"
import script from "./AddVideoPage.vue?vue&type=script&lang=js"
export * from "./AddVideoPage.vue?vue&type=script&lang=js"

import "./AddVideoPage.vue?vue&type=style&index=0&id=c27ee726&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c27ee726"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QStepper from 'quasar/src/components/stepper/QStepper.js';
import QStep from 'quasar/src/components/stepper/QStep.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QStepperNavigation from 'quasar/src/components/stepper/QStepperNavigation.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QUploader from 'quasar/src/components/uploader/QUploader.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QStepper,QStep,QIcon,QStepperNavigation,QBtn,QUploader});qInstall(script, 'directives', {Ripple});
